import update from 'immutability-helper';
import { handleActions } from 'redux-actions';

import {
  CONNECT_TO_WEB_SOCKET,

  //booking
  LOAD_BOOKING_SLOT_LIST,
  LOAD_BOOKING_SLOT_LIST_SUCCESS,
  LOAD_BOOKING_SLOT_LIST_ERROR,
  LOAD_NEXT_AVAILABLE_BOOKING_SLOT_LIST,
  LOAD_NEXT_AVAILABLE_BOOKING_SLOT_LIST_SUCCESS,
  LOAD_NEXT_AVAILABLE_BOOKING_SLOT_LIST_LIST_ERROR,
  HOLD_BOOKING_SLOT,
  HOLD_BOOKING_SLOT_SUCCESS,
  HOLD_BOOKING_SLOT_ERROR,

  //set hold booking slot
  SET_HOLD_BOOKING_SLOT,

  //Release slot
  RELEASE_BOOKING_SLOT,
  RELEASE_BOOKING_SLOT_SUCCESS,
  RELEASE_BOOKING_SLOT_ERROR,

  //create booking
  CREATE_BOOKING_SUCCESS,
  CREATE_BOOKING_ERROR,
} from '../type';
import { initialState } from './initialize';

const bookingReducer = handleActions(
  new Map([
    [
      CONNECT_TO_WEB_SOCKET,
      state => {
        return update(state, {
          loadingStatus: {
            loadBookingSlotLoading: { $set: true },
          },
        });
      },
    ],
    [
      LOAD_BOOKING_SLOT_LIST,
      state => {
        return update(state, {
          loadingStatus: {
            loadBookingSlotLoading: { $set: true },
          },
        });
      },
    ],
    [
      LOAD_BOOKING_SLOT_LIST_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            loadBookingSlotLoading: { $set: false },
          },
          bookingSlots: { $set: action.payload },
        });
      },
    ],
    [
      LOAD_BOOKING_SLOT_LIST_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            loadBookingSlotLoading: { $set: false },
          },
        });
      },
    ],
    [
      LOAD_NEXT_AVAILABLE_BOOKING_SLOT_LIST,
      state => {
        return update(state, {
          loadingStatus: {
            loadNextAvailableBookingSlotLoading: { $set: true },
          },
        });
      },
    ],
    [
      LOAD_NEXT_AVAILABLE_BOOKING_SLOT_LIST_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            loadNextAvailableBookingSlotLoading: { $set: false },
          },
          nextAvailableBookingSlots: { $set: action.payload },
        });
      },
    ],
    [
      LOAD_NEXT_AVAILABLE_BOOKING_SLOT_LIST_LIST_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            loadNextAvailableBookingSlotLoading: { $set: false },
          },
        });
      },
    ],
    [
      HOLD_BOOKING_SLOT,
      state => {
        return update(state, {
          loadingStatus: {
            loadBookingSlotLoading: { $set: true },
          },
        });
      },
    ],
    [
      HOLD_BOOKING_SLOT_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            loadBookingSlotLoading: { $set: false },
          },
          bookingSlotHolding: { $set: action.payload },
        });
      },
    ],
    [
      HOLD_BOOKING_SLOT_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            loadBookingSlotLoading: { $set: false },
          },
          bookingSlotHolding: { $set: {} },
        });
      },
    ],
    [
      SET_HOLD_BOOKING_SLOT,
      (state, action) => {
        return update(state, {
          bookingSlotHolding: { $set: action.payload },
        });
      },
    ],

    [
      RELEASE_BOOKING_SLOT,
      state => {
        return update(state, {
          loadingStatus: {
            loadBookingSlotLoading: { $set: true },
          },
        });
      },
    ],
    [
      RELEASE_BOOKING_SLOT_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            loadBookingSlotLoading: { $set: false },
          },
        });
      },
    ],
    [
      RELEASE_BOOKING_SLOT_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            loadBookingSlotLoading: { $set: false },
          },
          bookingSlotHolding: { $set: {} },
        });
      },
    ],
    [
      CREATE_BOOKING_SUCCESS,
      (state, action) => {
        return update(state, {
          isHoldingCreateBooking: { $set: false },
          appointmentCreated: { $set: action.payload },
        });
      },
    ],
    [
      CREATE_BOOKING_ERROR,
      (state, action) => {
        return update(state, { isHoldingCreateBooking: { $set: true } });
      },
    ],
  ]),
  initialState,
);

export default bookingReducer;
